import { useI18n } from "@/context/I18nContext";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex items-center rounded-full border border-amber-500/25 bg-black/40 p-0.5 ${compact ? "text-xs" : "text-sm"}`} data-testid="language-switcher">
      {["en", "id"].map((l) => (
        <button
          key={l}
          data-testid={`language-switcher-${l}`}
          onClick={() => setLang(l)}
          className={`px-2.5 py-1 rounded-full font-semibold uppercase transition-all ${
            lang === l ? "bg-gradient-to-r from-amber-400 to-amber-600 text-black" : "text-slate-300 hover:text-amber-400"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
